import $ from 'jquery';
import triggerChatFlow from '~src/utils/triggerChatFlow';

export const dispalySubscritionDetails = async (org) => {
  // Simple display of available fields without calculations
  const toDisplayDate = (value) => {
    if (!value) return null;
    if (typeof value === 'string') {
      const [datePart] = value.split('T');
      const parts = (datePart || '').split('-');
      if (parts.length === 3) {
        const [yy, mm, dd] = parts;
        return `${dd}-${mm}-${yy}`;
      }
      return value;
    }
    if (typeof value === 'object') {
      if (typeof value.iso === 'string') return toDisplayDate(value.iso);
      if (value instanceof Date && typeof value.toISOString === 'function')
        return toDisplayDate(value.toISOString());
    }
    return String(value);
  };

  const startedAtText = toDisplayDate(org.subscription_started_at);
  if (startedAtText) {
    $('#subscription-created-at').html(
      `Abbonamento iniziato il<br><strong>${startedAtText}</strong>`
    );
  }

  if (org.recurring_billing_frequency) {
    const freqLabel =
      org.recurring_billing_frequency === 'month'
        ? 'Mensile'
        : org.recurring_billing_frequency === 'year'
        ? 'Annuale'
        : org.recurring_billing_frequency;
    $('#subscription-next-invoice-at').html(
      `Frequenza fatturazione<br><strong>${freqLabel}</strong>`
    );
  }

  $('#subscription-plan-name').append(org.plan);
  if (org.limite_servizi != null) {
    $('#subscription-services-included').html(
      `Numero servizi<br><strong>${org.limite_servizi}</strong>`
    );
  }

  $('body').on('click', '#btn-cancel-subscription', () => {
    triggerChatFlow('hs_g_churn');
  });
};
